//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from "../common/helpers/HttpHelper";
import environments from "../common/environments/environment";
const http = new httpHelper();


export const FooterActions = {
    GetFooterJSON: getFooterJSON
}

function getFooterJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.FOOTER);
}
